import React from "react";
import clsx from "clsx";
// import _get from "lodash/get";
// import { gtmNotify } from "../../../utils/Analytics/index";
import { ThumbDownIcon } from "../../icons/thumb-down";
import { ThumbUpIcon } from "../../icons/thumb-up";
import * as styles from "./index.module.scss";

export function RatingButton({
  value = "neutral",
  onClick,
  big = false,
  customClass = "",
  disabled = false,
  analitycsLabel = null,
}) {
  const iconSize = big ? 32 : 24;

  const handleClick = (rating) => {
    onClick(rating);

    // const action = {
    //   "/ratings": "My Ratings",
    //   "/next": "My Club",
    // }[_get(window, "location.pathname", "")];

    // if (analitycsLabel) gtmNotify(action, analitycsLabel);
  };

  return (
    <div className={customClass}>
      <button
        type="button"
        aria-label="Negative rating"
        data-testid="negativeBtn"
        onClick={() => handleClick("negative")}
        className={clsx(
          styles.button,
          styles.down,
          value === "negative" && styles.active,
        )}
        disabled={disabled}
      >
        <ThumbDownIcon size={iconSize} />
      </button>
      <button
        type="button"
        aria-label="Positive rating"
        data-testid="positiveBtn"
        onClick={() => handleClick("positive")}
        className={clsx(styles.button, value === "positive" && styles.active)}
        disabled={disabled}
      >
        <ThumbUpIcon size={iconSize} />
      </button>
    </div>
  );
}
